/*
 * Copyright (c) 2023, tuanchauict
 */

package mono.ui.theme

/**
 * A class enumerating supported themes.
 */
enum class ThemeMode {
    LIGHT,
    DARK
}
